import { FiDateFormatOptions } from '@fi-shared/utils/format-date';
import { FiTranslationStatus } from './translation-status';
import { FiAppSettings } from '@fi-shared/fi-app-settings';
import { IDocumentContentModel } from '@fi-app/document/document';
import { Injector } from '@angular/core';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

export class DocumentContentModel implements IDocumentContentModel {
    Id = 0;
    DocumentId = 0;
    ContentLanguageId = 0;
    DocumentVersion = 1;
    DocumentVersionText = '';
    //Content = '';
    ContentHash = '';
    TranslationStatus: FiTranslationStatus = FiAppSettings.DefaultTranslationStatus;
    IsPublished = false;
    CreatedByUserId = 0;
    CreatedByUserName = '';
    CreatedOn = new Date();
    CreatedOnDate = '';

    Initialize(documentContent, preferredContentLanguage: number, injector: Injector) {
        this.Id = documentContent.Id;
        this.DocumentId = documentContent.DocumentId;
        this.ContentLanguageId = documentContent.ContentLanguageId;
        this.DocumentVersion = documentContent.DocumentVersion;
        this.TranslationStatus = documentContent.TranslationStatus;
        this.IsPublished = documentContent.IsPublished;
        //this.Content = documentContent.Content;
        this.ContentHash = documentContent.ContentHash;
        this.CreatedByUserId = documentContent.CreatedByUserId;
        this.CreatedByUserName = documentContent.CreatedByUserName;
        this.CreatedOn = documentContent.CreatedOn;
        this.CreatedOnDate = injector.get(FiFormatDateService).formatDate(this.CreatedOn, FiDateFormatOptions);
        if (this.ContentLanguageId === preferredContentLanguage)
            // if its default language translation status is set to translated by default
            this.TranslationStatus = FiTranslationStatus.Translated;
    }
}
